import React from "react";
import api from "@/lib/api";

const SIZES = {
  sm: "h-8 w-8 text-xs",
  md: "h-11 w-11 text-sm",
  lg: "h-16 w-16 text-2xl",
};

function initials(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

/**
 * Patient photo with an initials fallback.
 *
 * The <img> works because get_current_user reads the access_token COOKIE before
 * the Authorization header, and our axios client sets withCredentials — a bare
 * <img> can send a cookie but not a Bearer header. Same mechanism the clinical
 * photo grid already relies on.
 *
 * `updatedAt` is the cache-buster: the stored filename changes on replace, but
 * this keeps a mid-flight browser cache from showing the old face.
 */
export default function PatientAvatar({ patientId, name, photoPath, updatedAt, size = "md", className = "" }) {
  const [failed, setFailed] = React.useState(false);
  const dim = SIZES[size] || SIZES.md;
  const showPhoto = patientId && photoPath && !failed;

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-navy/10 font-display font-semibold text-navy ${dim} ${className}`}
      title={name || ""}
    >
      {showPhoto ? (
        <img
          src={`${api.defaults.baseURL}/patients/${patientId}/photo${updatedAt ? `?v=${encodeURIComponent(updatedAt)}` : ""}`}
          alt={name || "Patient"}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        initials(name)
      )}
    </div>
  );
}
